import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {login} from "./actions/authAction";
import {Formik, Form, Field, ErrorMessage} from "formik";
import * as Yup from "yup";
import LoginButton from "../buttons/LoginButton";
import styled from "styled-components";
import enjoyLogoWhite from '../../images/logo_EYB/logoEYBFullWhite.png'
import {SignInButton} from "../msal/msalButtons/SignInPopUpButton";

const LoginForm = () => {

    const mounted = useRef(false)
    const dispatch = useDispatch()
    const {message} = useSelector(state => state.auth)
    const [azureError, setAzureError] = useState("");
    let navigate = useNavigate()

    useEffect(() => {

    }, [azureError,setAzureError, message])
    return (
        <Formik
            initialValues={{username: "", password: ""}}
            validationSchema={Yup.object({
                username: Yup
                    .string()
                    .required('Veuillez écrire votre adresse mail'),
                password: Yup
                    .string()
                    .max(50, "Mot de passe trop long")
                    .required('Veuillez écrire votre mot de passe')
            })}
            onSubmit={(values, {setSubmitting}) => {
                dispatch(login(values))
                setSubmitting(false)
                navigate(1)
            }}
        >
            {({
                  isSubmitting, errors, touched
              }) => {
                return (
                    <StyledForm ref={mounted}>
                        <Form className="login-form">
                            <Label>
                                {
                                    errors.username && touched.username &&

                                    <p className={"error-text-with-bg"} style={{marginBottom: "0.5rem"}}><ErrorMessage
                                        name="username"/></p>
                                }
                                <Field type="email" name="username"
                                       placeholder={"Email"}/>
                            </Label>

                            <Label>
                                <Field type="password" name="password"
                                       placeholder={"Mot de passe"} autoComplete="on"/>
                                {
                                    errors.password && touched.password &&
                                    <p className={"error-text-with-bg"} style={{marginTop: "0.5rem"}}>
                                        <ErrorMessage className={"error-text"}
                                                      name="password"/></p>
                                }
                            </Label>
                            {
                                (message || azureError) &&
                                <div className='error'>
                                {message === "Invalid credentials." &&
                                        <p className={"error-text"}> Adresse email ou mot de passe invalide </p>
                                    }
                                    {(message === "Network Error" || message.includes("50")) &&
                                        <p className={"error-text"}> Oh oh, il semblerait qu'il n'y ai pas de
                                            connexion au réseau </p>
                                    }
                                    {
                                        message === "Request failed with status code 403" &&
                                        <p className={"error-text"}> Ce compte Microsoft n'est pas autorisé. Veuillez vous rapprocher de votre ambassadeur Enjoy.  </p>
                                    }
                                    {
                                        azureError  && !message &&
                                        <p className={"error-text"}> {azureError}</p>
                                    }

                                </div>
                            }
                            <>
                                <LoginButton
                                    isSubmitting={isSubmitting}
                                />
                                <SignInButton
                                    setAzureError={setAzureError}
                                />
                            </>

                            <ResetPassword
                                href={process.env.REACT_APP_PROXYLESS_URL + "reset-password"} target="_blank"
                                rel="noreferrer"> Mot de passe oublié ?  </ResetPassword>
                        </Form>
                    </StyledForm>
                );
            }}
        </Formik>
    )
}


const StyledForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    width: 80%;
    gap: 10px;
    height: 100%;
  }

  input {
    width: 100%;
    max-width: 450px;
    height: 40px;
    border-radius: 15px;
    border: none;
    padding-left: 1em;
    align-self: center;

    &:focus {
      outline: none;
    }
  }

  input[type=text] {
    padding-left: 1em;
    color: var(--color-white);
  }

  input::placeholder:focus {
    padding-left: 1em;
  }

  @media screen and (min-width: 900px) {
    form {
      align-items: center;
      height: 100%;
      justify-content: center;
    }
  }
`
const Label = styled.label`
  color: var(--color-white);;
  display: flex;
  flex-direction: column;
  width: 100%;

  p {
    height: 16px;
  }

  @media screen and (min-width: 900px) {
    width: 80%;
  }
`

const ResetPassword = styled.a`
  color: var(--color-white);
  width: 100%;
  text-align: center;
  text-decoration: underline;
  margin-top: 0.5em;
  &:hover {
    text-decoration: none;
    color: var(--color-purple-lighten);
  }
`
export default LoginForm;